import __var_0__ from './clippath.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Clipping path.
*
* @module @stdlib/plot/components/svg/clip-path
*
* @example
* var ClipPath = require( '@stdlib/plot/components/svg/clip-path' );
*
* var clipPath = new ClipPath({
*     'width': 400,
*     'height': 400
* });
*/

// MODULES //
var ClipPath = __var_0__;


// EXPORTS //
export default ClipPath;
